import React, { PropTypes } from 'react';
import axios from './../../../../constants/axios';
import { Table } from 'react-bootstrap';

class SaleInvoiceDetailPaymentHistory extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         invoicePaymentHistory: []
      };
   }

   componentDidMount() {
      const { invoiceId } = this.props.params;
      axios.get(`inventorySales/getInventoryPaymentHistoryByInvoiceId/${invoiceId}`)
         .then((res) => {
            this.setState({
               invoicePaymentHistory: res.data
            });
         });
   }

   render() {
      const { invoicePaymentHistory } = this.state;
      return (
         <div >
            <h4 >Invoice Payment History</h4 >
            <Table >
               <thead >
               <tr >
                  <th >Id</th >
                  <th >Amount</th >
                  <th >Account</th >
                  <th >Time</th >
                  <th >User</th >
               </tr >
               </thead >
               <tbody >
               {invoicePaymentHistory.map((history) => (
                  <tr key={history.id} >
                     <td >{history.id}</td >
                     <td >{history.amount}</td >
                     <td >{history.chart_of_account_name}</td >
                     <td >{history.event_time}</td >
                     <td >{history.user}</td >
                  </tr >
               ))}
               </tbody >
            </Table >
         </div >
      );
   }
}

SaleInvoiceDetailPaymentHistory.propTypes = {
   params: PropTypes.object
};

export default SaleInvoiceDetailPaymentHistory;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Sale/SaleInvoiceDetail/SaleInvoiceDetailPaymentHistory.js
 **/